import React from "react";
import { useTranslation } from "react-i18next";
import ConfirmModal from "../common/ConfirmModal";

/**
 * In-app confirmation for creating / dropping a real (physical) database index
 * on a column.
 *
 * target: { fieldName, currentlyOn } | null
 *   currentlyOn === true  → confirming a DROP
 *   currentlyOn === false → confirming a CREATE
 */
export default function DbIndexConfirmModal({ target, onConfirm, onCancel }) {
  const { t } = useTranslation();
  if (!target) return null;

  const { fieldName, currentlyOn } = target;
  const isDrop = !!currentlyOn;

  return (
    <ConfirmModal
      open
      variant={isDrop ? "warn" : "info"}
      icon={isDrop ? "⊘" : "#"}
      title={
        isDrop
          ? t("admin.dbIndexDropTitle", { defaultValue: "Turn off fast search" })
          : t("admin.dbIndexCreateTitle", { defaultValue: "Turn on fast search" })
      }
      name={fieldName}
      body={
        isDrop
          ? t("admin.dbIndexDropConfirm", {
              fieldName,
              defaultValue: `Turn off fast search for "${fieldName}"?`,
            })
          : t("admin.dbIndexCreateConfirm", {
              fieldName,
              defaultValue: `Make searches on "${fieldName}" fast? On a large table this runs in the background and may take a while.`,
            })
      }
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
